import { getDbMetaDataForSync } from 'src/api/offline/offlineApi';
import { useAppStore } from 'src/context/AppContext';
import useSyncOfflineAolItems from './useSyncOfflineAolItems';
import useSyncOfflineReportEvents from './useSyncOfflineReportEvents';
import useSyncOfflineBunkering from './useSyncOfflineBunkering';
import useSyncOfflineCargoTempLog from './useSyncOfflineCargoTempLog';
import useSyncOfflineStowageData from './useSyncOfflineStowageData';
import { useConnectionStore } from 'src/context/ConnectionContext';

const useSyncOfflineData = () => {
    const { syncReportEvents } = useSyncOfflineReportEvents();
    const { syncAolItems } = useSyncOfflineAolItems();
    const { syncBunkerings } = useSyncOfflineBunkering();
    const { syncOfflineCargoTempLog } = useSyncOfflineCargoTempLog();
    const { syncStowagePlanData } = useSyncOfflineStowageData();
    const { setAppModalData } = useAppStore();
    const { isOffline } = useConnectionStore();

    const syncOfflineData = async () => {
        const dbMetaData = await getDbMetaDataForSync();

        if (dbMetaData.itemCount === 0) return;

        setAppModalData({ title: 'Offline sync', message: 'You have been offline for a while. Please wait while we sync your offline data' });

        if (dbMetaData.storeCounts.reportEventsStore > 0) {
            await syncReportEvents();
        }
        if (dbMetaData.storeCounts.aolStore > 0) {
            await syncAolItems();
        }
        if (dbMetaData.storeCounts.bunkeringStore > 0) {
            await syncBunkerings();
        }
        if (dbMetaData.storeCounts.cargoTempLogStore > 0) {
            await syncOfflineCargoTempLog();
        }
        if (dbMetaData.storeCounts.stowageStore > 0) {
            await syncStowagePlanData();
        }
        setAppModalData(null);
    };

    const syncItemsIfHasOfflineNoonReports = async (noonReportId: number): Promise<number> => {
        if (isOffline || noonReportId > -1) return noonReportId;
        const syncedItems = await syncAolItems(true);
        if (!syncedItems) return noonReportId;
        const updatedNoonReportId = syncedItems[noonReportId];
        return updatedNoonReportId || noonReportId;
    };

    return {
        syncOfflineData,
        syncItemsIfHasOfflineNoonReports,
    };
};

export default useSyncOfflineData;
